(function () {
  let scrollPosition;

  document.addEventListener('turbo:load', () => {
    if (scrollPosition) {
      window.scrollTo(...scrollPosition);
      scrollPosition = null;
    }
  }, false);

  window.reloadTurbo = function () {
    scrollPosition = [window.scrollX, window.scrollY];
    Turbo.visit(window.location.href, { action: 'replace' });
  };

})();
